import {
  useCurrentOrganization,
  useOrganizationLimits,
  useSubscription,
} from '~publish/contexts/AccountContext'
import { usePostCounts } from '~publish/pages/AllChannels/PostList/usePostCounts'
import { useSelectedChannel } from '~publish/pages/Channel/ChannelContext'

const START_SHOWING_AT = 3

function useQueueLimitBar(): {
  postLimit: number
  numberOfScheduledPosts: number
  shouldShow: boolean
} {
  const organizationId = useCurrentOrganization()?.id
  const selectedChannel = useSelectedChannel()
  const selectedChannelId = selectedChannel?.id
  const { counts } = usePostCounts({
    organizationId,
    channelIds: selectedChannelId ? [selectedChannelId] : undefined,
  })
  const numberOfScheduledPosts = counts?.queue ?? 0
  const { scheduledPosts: postLimit } = useOrganizationLimits() ?? {}
  const subscription = useSubscription()
  const isFree = subscription?.plan?.id === 'free'
  const shouldShow = isFree && numberOfScheduledPosts >= START_SHOWING_AT

  return {
    numberOfScheduledPosts,
    postLimit: postLimit ?? 10,
    shouldShow,
  }
}

export default useQueueLimitBar
